<template>
   <div>
    <div class="c"></div>
    <div id="bd">
        <div class="cur">
            <div class="wp">您的当前位置：
                <router-link to="/"><a href="javascript:;" @click="menu_change(0)" tppabs="http://www.861ppt.com/122">主页</a></router-link> 
                > 
                <router-link to="khal"><a href="javascript:;" tppabs="http://www.861ppt.com/122/a/zhishiboke/">客户案例</a></router-link>
                > 
                <router-link to="khal"><a href="javascript" tppabs="http://www.861ppt.com/122/a/kehuanli/wangzhansheji/">标题</a></router-link>             
            </div>
        </div>
        <div class="wp case-article">
            <div class="article">
                <div class="wp pr">
                    <h1>客户案例标题</h1>
                    <p class="time">关键字:盘锦</p>
                    <div class="article-con ql-editor khal-con">
                        <video src="../assets/xz.mp4" width="100%" controls></video>
                        <!-- <p >描述描述描述描述描述描述描述描述描述描述</p>
                        <p >描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述</p> -->
                    </div>
                    <div class="h20"></div>
                </div>
            </div>
            <router-link to="khal">
                <div class="case-back">
                    <a href="javascript:;">返回案例列表</a>
                </div>
            </router-link>
        </div>
    </div>
</div>
</template>
<script>
export default {
    data(){
        return {
            title:'',
            content:''
        }
    },
    mounted(){
        //console.log(this.$route)
        this.$get("/api/xzsoft/website/khal/getCustomerCaseDetail",{id:this.$route.params.id}).then((response) => {
            //console.log("=====新闻类型")
            //console.log(response.data)
            this.title = response.data.title;
            this.content = response.data.content;
        }).catch(function(error) {
            //console.error("===")
            console.log(error,)
        })
    },
    methods:{
        menu_change(index){
            this.$store.dispatch('getNavbar',index) 
            //this.flag = index;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/khal_detail.vue